import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesLensItemMetricCardResponseModel } from '@/types/clarityLens'

export const getSalesLensItemMetricCard = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string,
  size: string,
  temperature: string
): Promise<SalesLensItemMetricCardResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-sales-lens/item/metric-card`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          item_group_name: itemGroupName,
          ...(size !== 'all' && {
            size: size.charAt(0).toUpperCase() + size.slice(1),
          }),
          ...(temperature !== 'all' && {
            style: temperature.charAt(0).toUpperCase() + temperature.slice(1),
          }),
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
